import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import Aura from '@primeng/themes/aura';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { authInterceptor } from './interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes), 
    provideAnimationsAsync(),
    provideHttpClient(
      // Removed withFetch() due to issues with custom headers (especially Authorization and api-key)
      // The default HttpClient (XMLHttpRequest) handles headers more reliably
      withInterceptors([authInterceptor])
    ),
    providePrimeNG({
      theme: {
        preset: Aura, // Apply your chosen theme preset
        options: {
          // Force app to stay in light mode regardless of browser/OS theme
          darkModeSelector: false
        }
      },
    }),
    MessageService,
  ]
};
